<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import appConfig from "@/app.config";
import { inboxAlert } from "@/state/inbox-alert";

export default {
  name: "app",
  /**
   * The browser tab, and the one place that owns it.
   *
   * ── Why the waiting count lives here ─────────────────────────────────
   * It used to be built into the inbox screen's own title, so the count was
   * only ever visible on the screen that already showed the queue. Here it
   * prefixes EVERY page, which is the point: an agent on Users, or with the
   * tab in the background behind the casino's own admin, sees `(3)` in the tab
   * strip without having to be looking at the inbox.
   *
   * ── Why `page` is a function ─────────────────────────────────────────
   * vue-meta only re-renders the title when something reactive read while
   * computing it changes. `titleTemplate` on a static object is invoked during
   * the merge, outside that tracking, so a count read in there would be
   * captured once and then go stale. Reading it here, in the function body,
   * makes the title a genuine dependency of the alert state.
   */
  page() {
    const waiting = inboxAlert.state.waiting;
    return {
      // All subcomponent titles will be injected into this template.
      titleTemplate(title) {
        title = typeof title === "function" ? title(this.$store) : title;
        const base = title ? `${title} | ${appConfig.title}` : appConfig.title;
        return waiting ? `(${waiting}) ${base}` : base;
      }
    };
  }
};
</script>
